/**
 * Public identity of the site: the name used as the <title> suffix until
 * the brand loads, and the canonical origin used for the sitemap and
 * canonical links. Plain constants so vite.config.ts can import them too.
 */
export const SITE_NAME = 'Real Estate with Shayaan';
export const SITE_URL = 'https://realestatewithshayaan.com';
